function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ACTIONS } from './actionTypes';
export function conversations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    searchResults: [],
    search: '',
    filter: 'all',
    items: {},
    list: [],
    paging: {},
    request: {},
    conversationsFetching: false,
    selectedConversation: null,
    currentView: 'inbox',
    collapsed: true,
    call: null,
    pip: false,
    members: [],
    onlineMembers: [],
    xGroup: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ACTIONS.SET_CONVERSATIONS_FILTER:
      {
        return _objectSpread(_objectSpread({}, state), {
          filter: action.filter
        });
      }
    case ACTIONS.SET_CONVERSATIONS_SEARCH:
      {
        return _objectSpread(_objectSpread({}, state), {
          search: action.search
        });
      }
    case ACTIONS.SET_CONVERSATIONS_SEARCH_RESULTS:
      {
        return _objectSpread(_objectSpread({}, state), {
          searchResults: action.results
        });
      }
    case ACTIONS.SET_CONVERSATIONS:
      {
        var append = action.request.offset > 0;
        if (Object.keys(state.items).length) {
          var items = _objectSpread({}, state.items);
          Object.keys(action.conversations.items).map(function (key) {
            return items[key] = _objectSpread(_objectSpread({}, items[key]), action.conversations.items[key]);
          });
          return _objectSpread(_objectSpread({}, state), {
            items: append ? _objectSpread(_objectSpread(_objectSpread({}, state.items), items), action.conversations.items) : _objectSpread(_objectSpread({}, state.items), items),
            list: append ? [].concat(_toConsumableArray(state.list), _toConsumableArray(action.conversations.list)) : action.conversations.list,
            paging: action.paging,
            request: action.request
          });
        }
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.conversations), {
          paging: action.paging,
          request: action.request
        });
      }
    case ACTIONS.SET_CONVERSATIONS_FETCHING_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {
          conversationsFetching: action.fetching
        });
      }
    case ACTIONS.SET_CONVERSATION:
    case ACTIONS.SET_CONVERSATION_MESSAGES:
      {
        var _items = _objectSpread({}, state.items);
        if (action.conversation.members) {
          delete action.conversation.members;
        }
        _items[action.conversation.id] = _objectSpread(_objectSpread({}, _items[action.conversation.id]), action.conversation);
        return _objectSpread(_objectSpread({}, state), {
          items: _items
        });
      }
    case ACTIONS.ADD_NOTIFICATION_MESSAGES:
      {
        var _items2 = _objectSpread({}, state.items);
        var conversation = _objectSpread({}, _items2[action.conversation.id]);
        Object.keys(action.conversation.authors).forEach(function (authorID) {
          if (!conversation.authors.hasOwnProperty(authorID)) {
            conversation.authors[authorID] = action.conversation.authors[authorID];
          }
        });
        conversation.messages = {
          items: _objectSpread(_objectSpread({}, conversation.messages.items), action.conversation.messages.items),
          list: [].concat(_toConsumableArray(conversation.messages.list), _toConsumableArray(action.conversation.messages.list))
        };
        conversation.totalMessages += action.conversation.newMessagesCount;
        _items2[action.conversation.id] = conversation;
        return _objectSpread(_objectSpread({}, state), {
          items: _items2
        });
      }
    case ACTIONS.RESET_NEW_MESSAGES_COUNT:
      {
        var _items3 = _objectSpread({}, state.items);
        var _conversation = _objectSpread({}, _items3[action.conversationID]);
        _conversation.newMessages = 0;
        _items3[_conversation.id] = _conversation;
        return _objectSpread(_objectSpread({}, state), {
          items: _items3
        });
      }
    case ACTIONS.ADD_CONVERSATION_MESSAGES:
      {
        var _items4 = _objectSpread({}, state.items);
        var _conversation2 = _objectSpread({}, _items4[action.conversation.id]);
        Object.keys(action.conversation.authors).forEach(function (authorID) {
          if (!_conversation2.authors.hasOwnProperty(authorID)) {
            _conversation2.authors[authorID] = action.conversation.authors[authorID];
          }
        });
        _conversation2.messages = {
          items: _objectSpread(_objectSpread({}, action.conversation.messages.items), _conversation2.messages.items),
          list: [].concat(_toConsumableArray(action.conversation.messages.list), _toConsumableArray(_conversation2.messages.list))
        };
        _items4[action.conversation.id] = _conversation2;
        return _objectSpread(_objectSpread({}, state), {
          items: _items4
        });
      }
    case ACTIONS.REPLACE_MESSAGE:
      {
        var _items5 = _objectSpread({}, state.items);
        var _conversation3 = _objectSpread({}, _items5[action.conversationID]);
        var messageIndex = _conversation3.messages.list.findIndex(function (messageID) {
          return messageID === action.message.created;
        });
        if (messageIndex !== -1) {
          delete _conversation3.messages.items[action.message.created];
          _conversation3.messages.list[messageIndex] = action.message.id;
          _conversation3.messages.items[action.message.id] = action.message;
          _conversation3.messages = {
            items: _objectSpread({}, _conversation3.messages.items),
            list: _toConsumableArray(_conversation3.messages.list)
          };
        }
        _items5[action.conversationID] = _conversation3;
        return _objectSpread(_objectSpread({}, state), {
          items: _items5
        });
      }
    case ACTIONS.ADD_NEW_MESSAGE:
      {
        var _items6 = _objectSpread({}, state.items);
        var _conversation4 = _objectSpread({}, _items6[action.conversationID]);
        if (!_conversation4.authors.hasOwnProperty(action.author.id)) {
          _conversation4.authors[action.author.id] = action.author;
        }
        _conversation4.messages.items[action.message.id] = action.message;
        _conversation4.messages.list.push(action.message.id);
        _conversation4.totalMessages += 1;
        _items6[action.conversationID] = _conversation4;
        return _objectSpread(_objectSpread({}, state), {
          items: _items6
        });
      }
    case ACTIONS.ADD_ADMINS:
      {
        var _items7 = _objectSpread({}, state.items);
        var _conversation5 = _objectSpread({}, _items7[action.conversationID]);
        _conversation5.admins = [].concat(_toConsumableArray(_conversation5.admins), _toConsumableArray(action.members));
        _items7[action.conversationID] = _conversation5;
        return _objectSpread(_objectSpread({}, state), {
          items: _items7
        });
      }
    case ACTIONS.REMOVE_ADMINS:
      {
        var _items8 = _objectSpread({}, state.items);
        var _conversation6 = _objectSpread({}, _items8[action.conversationID]);
        _conversation6.admins = _conversation6.admins.filter(function (id) {
          return !action.members.includes(id);
        });
        _items8[action.conversationID] = _conversation6;
        return _objectSpread(_objectSpread({}, state), {
          items: _items8
        });
      }
    case ACTIONS.ADD_MEMBER:
      {
        var _items9 = _objectSpread({}, state.items);
        var _conversation7 = _objectSpread({}, _items9[action.conversationID]);
        _conversation7.members = [action.member].concat(_toConsumableArray(_conversation7.members));
        _items9[action.conversationID] = _conversation7;
        return _objectSpread(_objectSpread({}, state), {
          items: _items9
        });
      }
    case ACTIONS.REMOVE_MEMBERS:
      {
        var _items10 = _objectSpread({}, state.items);
        var _conversation8 = _objectSpread({}, _items10[action.conversationID]);
        _conversation8.members = _conversation8.members.filter(function (member) {
          return !action.members.includes(member.id);
        });
        _items10[action.conversationID] = _conversation8;
        return _objectSpread(_objectSpread({}, state), {
          items: _items10
        });
      }
    case ACTIONS.REMOVE_CONVERSATION:
      {
        var _items11 = _objectSpread({}, state.items);
        var list = _toConsumableArray(state.list);
        var conversationIndex = list.indexOf(action.conversationID);
        delete _items11[action.conversationID];
        list.splice(conversationIndex, 1);
        return _objectSpread(_objectSpread({}, state), {
          items: _items11,
          list: list
        });
      }
    case ACTIONS.UPDATE_CURRENT_LAST_MESSAGE:
      {
        var _items12 = _objectSpread({}, state.items);
        var _list = _toConsumableArray(state.list);
        var _conversation9 = _objectSpread({}, _items12[action.conversationID]);
        var messages = _conversation9.messages;
        var lastMessageID = messages.list[messages.list.length - 1];
        var message = messages.items[lastMessageID];
        var author = _objectSpread({}, _conversation9.authors[message.author]);
        _conversation9.lastMessage = {
          alias: author.alias,
          text: message.body.text,
          created: message.created
        };
        _items12[_conversation9.id] = _conversation9;
        var _conversationIndex = _list.indexOf(_conversation9.id);
        if (_conversationIndex) {
          _list.splice(_conversationIndex, 1);
          _list.unshift(_conversation9.id);
          return _objectSpread(_objectSpread(_objectSpread({}, state), {
            items: _items12
          }), {
            list: _list
          });
        }
        return _objectSpread(_objectSpread({}, state), {
          items: _items12
        });
      }
    case ACTIONS.UPDATE_LAST_MESSAGE:
      {
        var _items13 = _objectSpread({}, state.items);
        var _list2 = _toConsumableArray(state.list);
        var order = action.conversations.map(function (conversation) {
          var currentConversation = _items13[conversation.id];
          if (currentConversation) {
            _items13[conversation.id] = _objectSpread(_objectSpread({}, currentConversation), conversation);
          } else {
            _items13[conversation.id] = _objectSpread({}, conversation);
          }
          return conversation.id;
        });
        var newList = _toConsumableArray(new Set([].concat(_toConsumableArray(order), _toConsumableArray(_list2))));
        var oldList = _list2;
        if (newList.join() !== oldList.join()) {
          return _objectSpread(_objectSpread(_objectSpread({}, state), {
            items: _items13
          }), {
            list: newList
          });
        }
        return _objectSpread(_objectSpread({}, state), {
          items: _items13
        });
      }
    case ACTIONS.UPDATE_CURRENT_TITLE:
      {
        var _items14 = _objectSpread({}, state.items);
        var _conversation10 = _objectSpread({}, _items14[action.conversationID]);
        _conversation10.title = action.title;
        _items14[action.conversationID] = _conversation10;
        return _objectSpread(_objectSpread({}, state), {
          items: _items14
        });
      }
    case ACTIONS.CONVERSATIONS_REORDER:
      {
        var _newList = action.conversationList;
        return _objectSpread(_objectSpread({}, state), {
          list: _newList
        });
      }
    case ACTIONS.UPDATE_MESSAGE:
      {
        var _items15 = _objectSpread({}, state.items);
        var _conversation11 = _objectSpread({}, _items15[action.conversationID]);
        _conversation11.messages.items[action.message.id] = action.message;
        _items15[action.conversationID] = _conversation11;
        return _objectSpread(_objectSpread({}, state), {
          items: _items15
        });
      }
    case ACTIONS.SET_SELECTED_CONVERSATION:
      {
        return _objectSpread(_objectSpread({}, state), {
          selectedConversation: action.conversationID
        });
      }
    case ACTIONS.SET_CURRENT_VIEW:
      {
        return _objectSpread(_objectSpread({}, state), {
          currentView: action.currentView
        });
      }
    case ACTIONS.SET_COLLAPSED:
      {
        return _objectSpread(_objectSpread({}, state), {
          collapsed: action.collapsed
        });
      }
    case ACTIONS.SET_ANNOUNCE_CALL:
      {
        return _objectSpread(_objectSpread({}, state), {
          call: action.from
        });
      }
    case ACTIONS.SET_REJECT_CALL:
      {
        return _objectSpread(_objectSpread({}, state), {
          call: null
        });
      }
    case ACTIONS.SET_PIP:
      {
        return _objectSpread(_objectSpread({}, state), {
          pip: action.pip
        });
      }
    case ACTIONS.SET_NEW_CONVERSATION_MEMBERS:
      {
        return _objectSpread(_objectSpread({}, state), {
          members: action.members
        });
      }
    case ACTIONS.SET_ONLINE_MEMBERS:
      {
        return _objectSpread(_objectSpread({}, state), {
          onlineMembers: _toConsumableArray(action.members)
        });
      }
    case ACTIONS.ADD_ONLINE_MEMBER:
      {
        return _objectSpread(_objectSpread({}, state), {
          onlineMembers: [].concat(_toConsumableArray(state.onlineMembers), [action.memberId])
        });
      }
    case ACTIONS.REMOVE_ONLINE_MEMBER:
      {
        return _objectSpread(_objectSpread({}, state), {
          onlineMembers: _toConsumableArray(state.onlineMembers).filter(function (item) {
            return item !== action.memberId;
          })
        });
      }
    case ACTIONS.SET_X_GROUP:
      {
        if (action.xGroup) {
          return _objectSpread(_objectSpread({}, state), {
            xGroup: action.xGroup
          });
        }
        return _objectSpread({}, state);
      }
    default:
      return state;
  }
}